
import { BusinessBranchModel } from 'tradingmate-modules/src/models/api/businesses'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BusinessCard extends Vue {
  @Prop({ required: true })
  private readonly businessBranch!: BusinessBranchModel
}
